// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
      suggestionStyle2MainContainerSelector: '.site'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
})();